const modOneData = {
  module: 1,
  category: 'Frontend Basics',
  days: [
    {
      link: "https://repl.it/@HannahHudson1/AdventDay1#index.js",
      emoji: "🎁"
    },
    {
      link: "https://codepen.io/hannahhch/pen/OJXGpxJ",
      emoji: "✉️"
    },
    {
      link: "https://github.com/turingschool-examples/ski-lift",
      emoji: "⛷️"
    },
    {
      link: "https://github.com/turingschool-examples/cookie-comp",
      emoji: "🍪"
    },
    {
      link: "https://repl.it/@HannahHudson1/Advent5#index.js",
      emoji: "🥳"
    },
    {
      link: "https://codepen.io/hannahhch/pen/QWEPeKb",
      emoji: "❄️"
    },
    {
      link: "https://codepen.io/hannahhch/pen/mdEYqjX",
      emoji: "🕛"
    },
    {
      link: "https://repl.it/@HannahHudson1/Advent8",
      emoji: "🥋"
    },
    {
      link: "https://github.com/turingschool-examples/do-you-wanna-build-a-snowman",
      emoji: "☃️"
    },
    {
      link: "https://github.com/turingschool-examples/winter-mad-libs",
      emoji: "📝"
    }
  ]
};

export default modOneData;
